import React from "react";

/**
 * @type {{
 *   app: import('firebase/app').FirebaseApp
 *   db: import('firebase/database').Database
 * }}
 */
const defaultValue = {
  app: null,
  db: null,
  messaging: null
};
const FirebaseContext = React.createContext(defaultValue);
export default FirebaseContext;